var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_1075)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_721_1075",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0H0V42H42V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.585 20.4545C14.9057 20.7744 14.9057 21.2937 14.585 21.6145C14.2651 21.9343 13.7459 21.9343 13.425 21.6145C13.1043 21.2937 13.1043 20.7744 13.425 20.4545C13.7459 20.1338 14.2651 20.1338 14.585 20.4545Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_721_1075)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_721_1075",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 43,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000183105 3.8147e-06H41.9998V42H-0.000183105V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_721_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.585 20.4545C14.9057 20.7744 14.9057 21.2937 14.585 21.6145C14.2651 21.9343 13.7459 21.9343 13.425 21.6145C13.1043 21.2937 13.1043 20.7744 13.425 20.4545C13.7459 20.1338 14.2651 20.1338 14.585 20.4545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3559 12.0439L23.1982 7.20077C25.4237 4.97526 28.4244 3.52487 31.3374 2.57913C36.3921 0.938507 41.1795 0.82038 41.1795 0.82038C41.1795 0.82038 41.0614 5.60772 39.4207 10.6625C38.475 13.5754 37.0246 16.5761 34.7991 18.8016L20.9654 32.6354L9.36456 21.0345L18.3559 12.0439Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9352 30.6051L16.3257 34.9552L7.0448 25.6743L11.3949 23.0648",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9568 23.6447L29.0865 31.4754L22.1261 38.4358L21.2558 32.345",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65494 20.744L3.56412 19.8737L10.5245 12.9133L18.3552 12.043",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36454 32.6353L0.82016 41.1797",
    stroke: "#1570EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6852 34.9552L6.62057 40.0198",
    stroke: "#1570EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04468 30.3147L1.98007 35.3793",
    stroke: "#1570EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5787 18.2217C27.9766 19.8237 25.3795 19.8237 23.7782 18.2217C22.1762 16.6204 22.1762 14.0233 23.7782 12.4212C25.3795 10.8201 27.9766 10.8201 29.5787 12.4212C31.1799 14.0233 31.1799 16.6204 29.5787 18.2217Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3373 2.57912L39.4207 10.6625",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3256 23.3543L23.2861 30.3147",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket_icon.b9933a7256a8845c8cdb5ce3e9cb39be.svg";
export { ForwardRef as ReactComponent };